<template>
  <div class="w-full" @paste="onPasteWindow">
    <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center" v-if="$atividades.permissoes.includes(14)">
      <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="cendter">
        <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
          <vs-col vs-type="flex" vs-w="6" vs-align="center" vs-justify="center">
            <h2>SOLICITAÇÃO DE SERVIÇO</h2>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="cendter">
        <div class="w-full">
          <vs-row vs-type="flex" vs-w="12" vs-align="start" vs-justify="start">
            <vs-col vs-type="flex" vs-w="3" vs-align="start" vs-justify="start">
              <vx-card class="w-full border" card-background="transparent" no-shadow no-border>
                <div class="w-full">
                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                      <vs-textarea
                        height="120"
                        v-validate="'required'"
                        disabled
                        label="AVISOS *"
                        class="w-full my-2 mx-2"
                        value="Você, o aprovador e a equipe de suporte receberão um email com o código da sua solicitação e de todos os detalhes informados. Por enquanto, o retorno será feito através do e-mail suporte@codinarts.com."
                      />
                    </vs-col>
                  </vs-row>
                </div>
              </vx-card>
            </vs-col>
            <vs-col vs-type="flex" vs-w="6" vs-align="start" vs-justify="start">
              <vx-card class="w-full border" no-shadow no-border>
                <div class="w-full">
                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="11.7" vs-align="center" vs-justify="start">
                      <vs-input
                        label="NOME DA SOLICITAÇÃO *"
                        v-model="solicitacao.nome"
                        class="w-full my-2 mx-2"
                        v-validate="'required'"
                      ></vs-input>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="0.3" vs-align="end" vs-justify="end">
                      <vx-tooltip
                        color="dark"
                        text="Título da Solicitação. Exemplo: Alteração no Kanban"
                      >
                        <vs-icon style="cursor: pointer" size="20px" icon="info" />
                      </vx-tooltip>
                    </vs-col>
                  </vs-row>
                  <!-- <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="6" vs-align="center" vs-justify="start">
                      <div class="w-full my-2 mx-2">
                        <vs-input
                          label="DATA *"
                          v-model="solicitacao.data"
                          class="w-full"
                          disabled
                          type="date"
                          v-validate="'required'"
                        />
                      </div>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="6" vs-align="center" vs-justify="start">
                      <div class="w-full my-2 mx-2">
                        <vs-input
                          label="NÚMERO *"
                          v-model="solicitacao.id"
                          disabled
                          class="w-full"
                          v-validate="'required'"
                        />
                      </div>
                    </vs-col>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="start">
                      <vs-input
                        label="CLIENTE *"
                        v-model="solicitacao.cliente"
                        class="w-full my-2 mx-2"
                        v-validate="'required'"
                      />
                    </vs-col>
                  </vs-row> -->
                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="11.7" vs-align="center" vs-justify="start">
                      <div class="w-full my-2 mx-2">
                        <label style="color: black; font-size: 0.85rem">APROVADOR *</label>
                        <el-select
                          filterable
                          v-model="solicitacao.id_aprovador"
                          clearable
                          v-validate="'required'"
                          class="w-full"
                          placeholder="Pesquise"
                          loading-text="Buscando..."
                          :popper-append-to-body="false"
                        >
                          <el-option
                            v-for="colaborador in colaboradores"
                            :value="colaborador.id"
                            :label="colaborador.nome"
                            :key="colaborador.id"
                          ></el-option>
                        </el-select>
                      </div>
                    </vs-col>
                    <vs-col vs-type="flex" vs-w="0.3" vs-align="end" vs-justify="end">
                      <vx-tooltip color="dark" text="Responsável pela solicitação. Exemplo: Thiago">
                        <vs-icon style="cursor: pointer" size="20px" icon="info" />
                      </vx-tooltip>
                    </vs-col>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="start">
                      <vs-input
                        v-validate="'required'"
                        v-model="solicitacao.descricao"
                        label="DESCRIÇÃO DA SOLICITAÇÃO *"
                        class="w-full my-2 mx-2"
                      />
                    </vs-col>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                      <vs-textarea
                        height="120"
                        v-validate="'required'"
                        v-model="solicitacao.comoFunciona"
                        label="COMO O SISTEMA FUNCIONA HOJE OU ERRO APRESENTADO (OPCIONAL)"
                        class="w-full my-2 mx-2"
                      />
                    </vs-col>
                  </vs-row>
                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                      <vs-textarea
                        v-validate="'required'"
                        height="120"
                        v-model="solicitacao.comoDeveria"
                        label="COMO O SISTEMA DEVERIA FUNCIONAR (OPCIONAL)"
                        class="w-full my-2 mx-2"
                      />
                    </vs-col>
                  </vs-row>

                  <!-- Seção de Anexo de Evidências / Arquivos (Opcional - até 50MB) -->
                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center" class="my-2 mx-2">
                    <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="start">
                      <div class="w-full">
                        <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 6px;">
                          <label style="color: #1E293B; font-size: 0.85rem; font-weight: 700; display: inline-flex; align-items: center; gap: 6px;">
                            <i class="material-icons" style="font-size: 18px; color: #2563EB;">collections</i>
                            ANEXAR EVIDÊNCIAS OU PRINTS DO ERRO (OPCIONAL)
                          </label>
                          <span v-if="arquivosEvidencia.length > 0" style="font-size: 12px; color: #2563EB; font-weight: 700; background-color: #EFF6FF; padding: 2px 10px; border-radius: 9999px; border: 1px solid #BFDBFE;">
                            📎 {{ arquivosEvidencia.length }} {{ arquivosEvidencia.length === 1 ? 'anexo incluído' : 'anexos incluídos' }}
                          </span>
                        </div>

                        <!-- Badges Informativas e Restrições Explícitas -->
                        <div style="display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 10px;">
                          <div style="display: inline-flex; align-items: center; gap: 6px; background-color: #ECFDF5; border: 1px solid #A7F3D0; color: #065F46; padding: 4px 10px; border-radius: 6px; font-size: 11px; font-weight: 600;">
                            <span style="font-size: 13px;">✓</span> ACEITA IMAGENS, DOCUMENTOS (PDF, WORD, EXCEL) E VÍDEOS (MP4, WEBM)
                          </div>
                          <div style="display: inline-flex; align-items: center; gap: 6px; background-color: #EFF6FF; border: 1px solid #BFDBFE; color: #1D4ED8; padding: 4px 10px; border-radius: 6px; font-size: 11px; font-weight: 600;">
                            <span style="font-size: 13px;">✓</span> LIMITE ATÉ 50 MB POR ARQUIVO
                          </div>
                        </div>
                        
                        <!-- Input file oculto (suporta múltiplos arquivos, imagens, docs, vídeos) -->
                        <input
                          type="file"
                          ref="fileInput"
                          style="display: none;"
                          multiple
                          accept="image/png, image/jpeg, image/jpg, image/gif, image/webp, image/svg+xml, application/pdf, .pdf, .doc, .docx, .xls, .xlsx, .txt, .csv, video/mp4, video/webm, video/quicktime, .mp4, .webm, .mov, .zip, .rar"
                          @change="onArquivoSelecionado"
                        />

                        <!-- Área de seleção / drag-and-drop / Ctrl+V -->
                        <div
                          class="upload-dropzone my-2 text-center cursor-pointer"
                          :class="{ 'dropzone-active': isDragging }"
                          @click="$refs.fileInput.click()"
                          @dragover.prevent="isDragging = true"
                          @dragenter.prevent="isDragging = true"
                          @dragleave.prevent="isDragging = false"
                          @drop="onDropArquivo"
                          :style="{
                            border: isDragging ? '2px dashed #2563EB' : '2px dashed #CBD5E1',
                            borderRadius: '10px',
                            backgroundColor: isDragging ? '#EFF6FF' : '#F8FAFC',
                            transition: 'all 0.2s ease',
                            padding: '24px 16px'
                          }"
                        >
                          <div style="width: 52px; height: 52px; border-radius: 50%; background-color: #EFF6FF; display: flex; align-items: center; justify-content: center; margin: 0 auto 10px auto;">
                            <vs-icon icon="cloud_upload" size="32px" color="#2563EB"></vs-icon>
                          </div>
                          <div style="font-size: 14px; font-weight: 600; color: #1E293B;">
                            Arraste e solte seus arquivos aqui (imagens, PDFs, documentos ou vídeos), ou <span style="color: #2563EB; text-decoration: underline;">clique para navegar</span>
                          </div>
                          <div style="font-size: 12px; color: #64748B; margin-top: 4px;">
                            Suporte nativo a <strong>Ctrl+V</strong> para colar capturas de tela diretamente da área de transferência
                          </div>
                        </div>

                        <!-- Barra de ações se houver arquivos -->
                        <div v-if="arquivosEvidencia.length > 0" style="display: flex; justify-content: space-between; align-items: center; margin-top: 14px; margin-bottom: 8px;">
                          <span style="font-size: 13px; font-weight: 700; color: #334155;">
                            Arquivos Anexados ({{ arquivosEvidencia.length }}):
                          </span>
                          <vs-button
                            v-if="temMidiasParaCarrossel"
                            type="flat"
                            size="small"
                            icon="visibility"
                            color="primary"
                            @click="abrirLightbox(0)"
                            title="Navegar pelas imagens/vídeos com setas em tela cheia"
                          >
                            Visualizar em Carrossel ({{ midiasCarrossel.length }})
                          </vs-button>
                        </div>

                        <!-- Grade de Miniaturas / Cards com Preview Interativo -->
                        <div v-if="arquivosEvidencia.length > 0" class="my-2" style="display: grid; grid-template-columns: repeat(auto-fill, minmax(200px, 1fr)); gap: 12px;">
                          <div
                            v-for="(item, index) in arquivosEvidencia"
                            :key="item.id || index"
                            class="evidence-thumb-card"
                            style="border: 1px solid #E2E8F0; border-radius: 8px; background-color: #FFFFFF; overflow: hidden; box-shadow: 0 1px 3px rgba(0,0,0,0.05); display: flex; flex-direction: column; transition: transform 0.2s, box-shadow 0.2s;"
                          >
                            <!-- Thumbnail com Imagem ou Ícone de Documento/Vídeo -->
                            <div
                              v-if="item.tipo === 'image'"
                              class="thumb-image-container"
                              style="position: relative; width: 100%; height: 120px; background-color: #F1F5F9; cursor: pointer; overflow: hidden; display: flex; align-items: center; justify-content: center;"
                              @click="abrirVisualizacaoItem(item, index)"
                              title="Clique para abrir e navegar nas evidências"
                            >
                              <img
                                :src="item.preview"
                                style="width: 100%; height: 100%; object-fit: cover;"
                                :alt="item.nome"
                              />
                              <!-- Badge com número da imagem -->
                              <span style="position: absolute; top: 6px; left: 6px; background-color: rgba(15, 23, 42, 0.75); color: white; padding: 2px 7px; border-radius: 4px; font-size: 11px; font-weight: 700;">
                                #{{ index + 1 }}
                              </span>
                              <!-- Overlay de Ação -->
                              <div
                                class="thumb-hover-overlay"
                                style="position: absolute; inset: 0; background-color: rgba(15, 23, 42, 0.45); display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 4px; color: white; opacity: 0; transition: opacity 0.2s;"
                              >
                                <vs-icon icon="zoom_in" size="26px" color="#FFFFFF"></vs-icon>
                                <span style="font-size: 11px; font-weight: 600;">Ver em tela cheia</span>
                              </div>
                            </div>

                            <div
                              v-else-if="item.tipo === 'video'"
                              class="thumb-image-container"
                              style="position: relative; width: 100%; height: 120px; background-color: #0F172A; cursor: pointer; overflow: hidden; display: flex; flex-direction: column; align-items: center; justify-content: center;"
                              @click="abrirVisualizacaoItem(item, index)"
                              title="Clique para reproduzir vídeo"
                            >
                              <i class="material-icons" style="font-size: 40px; color: #A855F7;">videocam</i>
                              <span style="position: absolute; top: 6px; left: 6px; background-color: rgba(168, 85, 247, 0.9); color: white; padding: 2px 7px; border-radius: 4px; font-size: 10px; font-weight: 700;">
                                VÍDEO #{{ index + 1 }}
                              </span>
                              <span style="font-size: 11px; color: #CBD5E1; margin-top: 4px;">Reproduzir</span>
                            </div>

                            <div
                              v-else
                              style="position: relative; width: 100%; height: 120px; background-color: #F8FAFC; cursor: pointer; overflow: hidden; display: flex; flex-direction: column; align-items: center; justify-content: center; padding: 12px;"
                              @click="abrirVisualizacaoItem(item, index)"
                              title="Clique para abrir documento"
                            >
                              <i
                                class="material-icons"
                                :style="{ fontSize: '40px', color: item.tipo === 'pdf' ? '#DC2626' : '#2563EB' }"
                              >
                                {{ item.tipo === 'pdf' ? 'picture_as_pdf' : 'description' }}
                              </i>
                              <span
                                style="position: absolute; top: 6px; left: 6px; color: white; padding: 2px 6px; border-radius: 4px; font-size: 10px; font-weight: 700;"
                                :style="{ backgroundColor: item.tipo === 'pdf' ? 'rgba(220, 38, 38, 0.9)' : 'rgba(37, 99, 235, 0.9)' }"
                              >
                                {{ (item.tipo || 'DOC').toUpperCase() }} #{{ index + 1 }}
                              </span>
                            </div>

                            <!-- Info do arquivo e botões -->
                            <div style="padding: 10px; display: flex; flex-direction: column; gap: 6px; flex: 1; justify-content: space-between;">
                              <div>
                                <div style="font-size: 12px; font-weight: 600; color: #1E293B; text-overflow: ellipsis; white-space: nowrap; overflow: hidden;" :title="item.nome">
                                  {{ item.nome }}
                                </div>
                                <div style="font-size: 11px; color: #64748B; margin-top: 2px;">
                                  {{ item.tamanhoFormatado }}
                                </div>
                              </div>
                              <div style="display: flex; justify-content: space-between; align-items: center; margin-top: 4px; border-top: 1px solid #F1F5F9; padding-top: 6px;">
                                <button
                                  type="button"
                                  @click="abrirVisualizacaoItem(item, index)"
                                  style="border: none; background: transparent; cursor: pointer; color: #2563EB; font-size: 11px; font-weight: 600; display: inline-flex; align-items: center; gap: 3px;"
                                >
                                  <vs-icon :icon="item.tipo === 'image' || item.tipo === 'video' ? 'visibility' : 'open_in_new'" size="14px"></vs-icon>
                                  {{ item.tipo === 'image' || item.tipo === 'video' ? 'Ver' : 'Abrir' }}
                                </button>
                                <button
                                  type="button"
                                  @click="removerArquivo(index)"
                                  style="border: none; background: transparent; cursor: pointer; color: #EF4444; font-size: 11px; font-weight: 600; display: inline-flex; align-items: center; gap: 3px;"
                                  title="Remover este anexo"
                                >
                                  <vs-icon icon="delete" size="14px"></vs-icon> Excluir
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- Modal Lightbox Navegável com Setas < e > -->
                        <image-lightbox-modal
                          :active.sync="lightboxAtivo"
                          :images="midiasCarrossel"
                          :initial-index="lightboxIndex"
                        />
                      </div>
                    </vs-col>
                  </vs-row>

                  <vs-row vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                    <vs-col vs-type="flex" vs-w="12" vs-align="center" vs-justify="center">
                      <vs-button
                        class="w-full"
                        color="success"
                        type="relief"
                        icon="send"
                        @click="criarTicket()"
                      >ENVIAR SOLICITAÇÃO</vs-button>
                    </vs-col>
                  </vs-row>
                </div>
              </vx-card>
            </vs-col>
          </vs-row>
        </div>
      </vs-col>
    </vs-row>
    <v-row v-else>
        {{ this.$vs.notify({title: "Não autorizado", text: "Você não tem autorização para criar tickets", color: "danger"}) }}
    </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      colaboradores: [],
      solicitacao: {  
        id_criador: null,
        nome: null,
        comoDeveria: null,
        comoFunciona: null,
        descricao: null,
        id_aprovador: null,
      },
      arquivosEvidencia: [],
      isUploadingImagem: false,
      lightboxAtivo: false,
      lightboxIndex: 0,
      isDragging: false
    };
  },
  computed: {
    midiasCarrossel() {
      return (this.arquivosEvidencia || []).filter(function(item) {
        return item.tipo === 'image' || item.tipo === 'video';
      });
    },
    temMidiasParaCarrossel() {
      return this.midiasCarrossel.length > 0;
    }
  },
  methods: {
    async montarInfoSolicitacao() {
      await this.getAprovadores();
      this.solicitacao.id_criador = localStorage.getItem("id");
    },
    async getAprovadores() {
      try {
        this.colaboradores = await this.$http.get("getAprovadores");
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }
    },
    identificarTipoArquivo(file) {
      if (!file) return 'document';
      var name = (file.name || '').toLowerCase();
      var type = (file.type || '').toLowerCase();
      if (type.startsWith('image/') || /\.(png|jpe?g|gif|webp|svg)$/.test(name)) return 'image';
      if (type.startsWith('video/') || /\.(mp4|webm|mov|mkv|avi)$/.test(name)) return 'video';
      if (type === 'application/pdf' || /\.pdf$/.test(name)) return 'pdf';
      if (type.includes('word') || /\.(docx?|txt)$/.test(name)) return 'document';
      if (type.includes('excel') || type.includes('spreadsheet') || /\.(xlsx?|csv)$/.test(name)) return 'document';
      if (type.includes('zip') || type.includes('rar') || /\.(zip|rar)$/.test(name)) return 'document';
      return 'document';
    },
    onArquivoSelecionado(event) {
      var files = (event && event.target && event.target.files) ? event.target.files : [];
      for (var i = 0; i < files.length; i++) {
        this.processarArquivo(files[i]);
      }
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    },
    onDropArquivo(event) {
      event.preventDefault();
      this.isDragging = false;
      var files = (event && event.dataTransfer && event.dataTransfer.files) ? event.dataTransfer.files : [];
      for (var i = 0; i < files.length; i++) {
        this.processarArquivo(files[i]);
      }
    },
    onPasteWindow(event) {
      var clipboardData = event.clipboardData || (window.clipboardData ? window.clipboardData : null);
      if (!clipboardData) return;
      var items = clipboardData.items;
      if (!items) return;
      var encontrouImagem = false;
      for (var i = 0; i < items.length; i++) {
        if (items[i].type && items[i].type.indexOf('image/') !== -1) {
          var file = items[i].getAsFile();
          if (file) {
            var nomePadrao = 'print_evidencia_' + (this.arquivosEvidencia.length + 1) + '.png';
            this.processarArquivo(file, nomePadrao);
            encontrouImagem = true;
          }
        }
      }
      if (encontrouImagem && this.$vs && this.$vs.notify) {
        this.$vs.notify({
          title: "Imagem Colada!",
          text: "Evidência da área de transferência adicionada com sucesso.",
          color: "success"
        });
      }
    },
    processarArquivo(file, nomeCustom) {
      if (!file) return;
      var MAX_SIZE = 50 * 1024 * 1024; // 50 MB
      if (file.size > MAX_SIZE) {
        this.$vs.notify({
          title: "Arquivo excede o limite",
          text: "O tamanho máximo permitido para cada evidência é de 50 MB.",
          color: "danger"
        });
        return;
      }
      var extensoesPermitidas = [
        'png', 'jpg', 'jpeg', 'gif', 'webp', 'svg',
        'pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'csv',
        'mp4', 'mov', 'webm', 'zip', 'rar'
      ];
      var ext = file.name ? file.name.split('.').pop().toLowerCase() : '';
      var type = (file.type || '').toLowerCase();
      var isPermitido = extensoesPermitidas.indexOf(ext) !== -1 ||
        type.startsWith('image/') ||
        type.startsWith('video/') ||
        type === 'application/pdf' ||
        type.includes('word') ||
        type.includes('excel') ||
        type.includes('spreadsheet') ||
        type.startsWith('text/') ||
        type.includes('zip') ||
        type.includes('rar');

      if (!isPermitido) {
        this.$vs.notify({
          title: "Formato não aceito",
          text: "Por favor, selecione imagens (PNG, JPG, WebP), documentos (PDF, Word, Excel) ou vídeos (MP4, WebM) de até 50 MB.",
          color: "warning"
        });
        return;
      }

      var tipo = this.identificarTipoArquivo(file);
      var nome = nomeCustom || file.name || ('evidencia_' + (this.arquivosEvidencia.length + 1) + (tipo === 'image' ? '.png' : ''));
      var tamanhoFormatado = (file.size / (1024 * 1024)).toFixed(2) + ' MB';
      var blobUrl = (window.URL && typeof window.URL.createObjectURL === 'function') ? window.URL.createObjectURL(file) : null;
      var self = this;

      if (tipo === 'image') {
        var reader = new FileReader();
        reader.onload = function(e) {
          self.arquivosEvidencia.push({
            id: Date.now() + Math.random(),
            file: file,
            tipo: tipo,
            preview: e.target.result,
            blobUrl: blobUrl,
            nome: nome,
            tamanhoFormatado: tamanhoFormatado
          });
        };
        reader.readAsDataURL(file);
      } else {
        self.arquivosEvidencia.push({
          id: Date.now() + Math.random(),
          file: file,
          tipo: tipo,
          preview: blobUrl,
          blobUrl: blobUrl,
          nome: nome,
          tamanhoFormatado: tamanhoFormatado
        });
      }
    },
    abrirVisualizacaoItem(item, index) {
      if (!item) return;
      if (item.tipo === 'image' || item.tipo === 'video') {
        var idx = this.midiasCarrossel.findIndex(function(m) { return m.id === item.id; });
        this.abrirLightbox(idx >= 0 ? idx : 0);
      } else if (item.blobUrl) {
        window.open(item.blobUrl, '_blank');
      }
    },
    abrirLightbox(index) {
      this.lightboxIndex = index || 0;
      this.lightboxAtivo = true;
    },
    removerArquivo(index) {
      if (index >= 0 && index < this.arquivosEvidencia.length) {
        var item = this.arquivosEvidencia[index];
        if (item && item.blobUrl && window.URL && window.URL.revokeObjectURL) {
          window.URL.revokeObjectURL(item.blobUrl);
        }
        this.arquivosEvidencia.splice(index, 1);
      }
    },
    removerImagem(index) {
      this.removerArquivo(index);
    },
    async criarTicket(){
      if (!this.solicitacao.nome) {
        this.$vs.notify({
          title: "Campo obrigatório",
          text: "Informe o nome da solicitação.",
          color: "warning"
        });
        return;
      }
      this.$vs.loading();
      try{
        var payload = Object.assign({}, this.solicitacao);

        // Upload das evidências via multipart/form-data para ticket/upload-evidencia
        if (this.arquivosEvidencia && this.arquivosEvidencia.length > 0) {
          var linksEvidencias = [];
          for (var i = 0; i < this.arquivosEvidencia.length; i++) {
            var item = this.arquivosEvidencia[i];
            try {
              var formData = new FormData();
              formData.append("file", item.file, item.nome);
              formData.append("name", item.nome || "evidencia_ticket");

              var uploadRes = await this.$http.post("ticket/upload-evidencia", formData, {
                headers: { "Content-Type": "multipart/form-data" }
              });

              var uploadedUrl = (uploadRes && uploadRes.displayUrl) ? uploadRes.displayUrl : ((uploadRes && uploadRes.url) ? uploadRes.url : null);
              if (uploadedUrl) {
                if (item.tipo === 'image') {
                  linksEvidencias.push("![Evidência " + (i + 1) + "](" + uploadedUrl + ")\n[Ver imagem completa](" + uploadedUrl + ")");
                } else {
                  linksEvidencias.push("[📎 Evidência " + (i + 1) + " (" + (item.nome || 'arquivo') + ")](" + uploadedUrl + ")\n[Ver anexo completo](" + uploadedUrl + ")");
                }
              }
            } catch (uploadErr) {
              console.error("Falha no upload da evidência " + (i + 1) + ":", uploadErr);
            }
          }

          if (linksEvidencias.length > 0) {
            payload.descricao = (payload.descricao ? payload.descricao : "") +
              "\n\n### Evidências / Imagens\n" + linksEvidencias.join("\n\n");
          }
        }

        await this.$http.post("ticket", payload);
        this.$vs.notify({
          title: "Sucesso",
          text: "Ticket criado com sucesso",
          color: "success"
        });
        await this.limparFormulario();
      }catch(err){
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if(error.code == 401) {
         await window.localStorage.clear();
         await this.$router.push("/"); 
        };
      }finally {
        this.$vs.loading.close();
      }
    },
    async limparFormulario(){
      this.solicitacao.nome = "";
      this.solicitacao.id_aprovador = null;
      this.solicitacao.descricao = "";
      this.solicitacao.comoFunciona = "";
      this.solicitacao.comoDeveria = "";
      (this.arquivosEvidencia || []).forEach(function(item) {
        if (item && item.blobUrl && window.URL && window.URL.revokeObjectURL) {
          window.URL.revokeObjectURL(item.blobUrl);
        }
      });
      this.arquivosEvidencia = [];
      this.lightboxAtivo = false;
      this.isDragging = false;
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = '';
      }
    }
  },
  async mounted() {
    this._beforeEditingCache = Object.assign({}, this.solicitacao);
    await this.montarInfoSolicitacao();
    window.addEventListener("paste", this.onPasteWindow);
  },
  beforeDestroy() {
    window.removeEventListener("paste", this.onPasteWindow);
    (this.arquivosEvidencia || []).forEach(function(item) {
      if (item && item.blobUrl && window.URL && window.URL.revokeObjectURL) {
        window.URL.revokeObjectURL(item.blobUrl);
      }
    });
  }
};
</script>

<style>
.actions {
  width: 60px !important;
}
.upload-dropzone:hover {
  border-color: #3B82F6 !important;
  background-color: #EFF6FF !important;
}
.dropzone-active {
  border-color: #2563EB !important;
  background-color: #EFF6FF !important;
}
.evidence-thumb-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06) !important;
}
.thumb-image-container:hover .thumb-hover-overlay {
  opacity: 1 !important;
}
</style>
